
(function () {
    angular.module('tmx-app').directive("tmxCnic", tmxCnic);

    function tmxCnic() {
        return {
            scope: {
                label:"@",
                value:'=',
                onClick:"&",
                onNewCnic:'&',
                onStart:'&',
                onActiveCnic:'&',
                onRepeatCnic:'&',
                onSuccess:'&',
                onCheckStart:'&',
                onCheckComplete:'&',
            },
            restrict: 'E',
            templateUrl: 'common/directives/tmxcnic/tmxcnic.html',
            controller: ["$scope","$http","tmxUtility","APP_CONSTANTS","$mdDialog",cnicCtrl],
            controllerAs: 'cnicCtrl'
        };
    }
    var exists;
    function cnicCtrl($scope,$http,tmxUtility,APP_CONSTANTS,$mdDialog) {
        var vm=this;
        vm.submit=function(){
            if(exists($scope.onCheckStart()))
                $scope.onCheckStart()($scope.value);
            verifyCnic($http,$scope,$mdDialog,APP_CONSTANTS.backend+"ApplicantHistory/CNICCheck/",$scope.value,function(){if(exists($scope.onCheckComplete()))$scope.onCheckComplete()($scope.value)},$scope.onNewCnic,$scope.onActiveCnic,$scope.onRepeatCnic);
        }
        vm.isEmpty=function(){
            return !exists($scope.value);
        }
        exists=tmxUtility.exists;
    }

    function verifyCnic($http,$scope,$mdDialog,url,cnic,callback,onNewCNIC,onActiveCNIC,onRepeatCNIC){
        $http.get(url+cnic+"/1").then(function(response){
            var alertConfig={
                title: "CNIC Verfication",
                ok:'close'
            };
            var type="undefined";
            var _response;
            switch(response.data.status.code){
            case 200:
                if(response.data.data==null){
                }
                else{
                    _response=response.data.data;
                    if(!isNaN(_response)){//if response is a number then we have a repeat client and the number is its loan cycle
                        type="old_complete";
                    }
                    else if(_response=="CLEAR"){//if response is "CLEAR" then never seen this dude before
                        type="new";
                    }
                    else{
                        type="old_incomplete";
                    }
                }
                break;
            }

            switch(type){
            case "new":
                alertConfig.title="New Client";
                alertConfig.textContent="You're NOT an active Kashf Loan Applicant";
                if(exists(onNewCNIC()))onNewCNIC()($scope.value);
                break;
            case "old_complete":
                var cycle=parseInt(_response);
                alertConfig.title="Repeat Client";
                alertConfig.textContent="You're a repeat Kashf Loan Applicant, setting your loan cycle to "+cycle;
                if(exists(onRepeatCNIC()))onRepeatCNIC()($scope.value,cycle);
                break;
            case "old_incomplete":
                alertConfig.title="Already Active Client";
                alertConfig.textContent="You're already an "+_response;
                if(exists(onActiveCNIC()))onActiveCNIC()($scope.value);
                break;
            case "undefined":
                alertConfig.title="New Type of CNIC Discovered!";
                alertConfig.textContent="You my friend are unique!";
                break;
            }

            if(exists(callback)){
                callback(response);
            }
            $mdDialog
                .show($mdDialog.alert(alertConfig))
                .finally(function() {});
        });
    }

})();